import { StyledFooter } from "./style";

export default function Footer() {
  return <StyledFooter>&copy; 2020 Marlon Veiga</StyledFooter>;
}
